import { render } from "./CallbackView.vue?vue&type=template&id=8b3cff64&scoped=true"
import script from "./CallbackView.vue?vue&type=script&lang=js"
export * from "./CallbackView.vue?vue&type=script&lang=js"

import "./CallbackView.vue?vue&type=style&index=0&id=8b3cff64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3cff64"]])

export default __exports__